import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GA4_ID, GTM_ID } from "@/config/site";
import { getConsent, setConsent, initAnalytics } from "@/lib/analytics";

// Only shown when an analytics tool is actually configured.
export const ConsentBanner = () => {
  const configured = Boolean(GA4_ID || GTM_ID);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!configured) return;
    const c = getConsent();
    if (!c) setShow(true);
    else if (c === "granted") initAnalytics();
  }, [configured]);
  if (!show) return null;
  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie preferences" className="fixed inset-x-3 bottom-20 z-50 mx-auto max-w-xl rounded-2xl border bg-white p-5 shadow-[0_18px_50px_rgba(37,51,43,0.18)] sm:bottom-6" data-testid="cookie-consent-banner">
      <p className="text-sm leading-relaxed text-[#3d4a42]">
        We would like to use analytics cookies to understand how visitors use our website. You can accept or decline. See our{" "}
        <Link to="/privacy-policy" className="link-accent">
          privacy notice
        </Link>
        .
      </p>
      <div className="mt-4 flex gap-2">
        <button className="btn btn-primary" onClick={() => { setConsent("granted"); setShow(false); }} data-testid="cookie-consent-accept">Accept analytics</button>
        <button className="btn btn-outline" onClick={() => { setConsent("denied"); setShow(false); }} data-testid="cookie-consent-decline">Decline</button>
      </div>
    </div>
  );
};
